import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";

interface Props {
  isChangeFlow: boolean;
}

const NotRefWindowTitle = ({ isChangeFlow }: Props) => {
  const intl = useIntl();
  return (
    <WindowTitle
      title={intl.formatMessage(
        isChangeFlow
          ? sectionNames.notRefContractChange
          : sectionNames.notRefContract
      )}
    />
  );
};

export default NotRefWindowTitle;
